import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** What a To Do item holds and how things leave it, shown behind the help
 *  icon after the item's title. */
export interface TodoHint {
	heading: string;
	body: string;
}

export const TodoHintBody = ({ hint }: { hint: TodoHint }) => (
	<Box data-component="todo-hint-body">
		<Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>
			{hint.heading}
		</Typography>
		<Typography variant="body2">{hint.body}</Typography>
	</Box>
);

export const TODO_HINTS = {
	allNeedsAttention: {
		heading: "Waiting for your answer",
		body: "People whose latest message to you has not been answered yet. Answer them, or Mark as Done if nothing is needed.",
	},
	pitchResponses: {
		heading: "Replies to your pitches",
		body: "Candidates who replied to one of your pitches and are waiting for your answer. Answer them, or Mark as Done if nothing is needed.",
	},
	staleConversations: {
		heading: "Candidates who went quiet",
		body: "The candidate replied to your pitch, you answered, and they have not written back for 7 days. Poke them, or Mark as Done to drop them. They leave the list on their own after 30 days, or when the role closes.",
	},
	expiredReminders: {
		heading: "Reminders that are due",
		body: "Reminders you set on candidates whose date has come. Open the person to act, then remove or postpone the reminder.",
	},
	expiredRemindersProspect: {
		heading: "Prospect reminders that are due",
		body: "Reminders that have come due on people you upvoted on the prospecting lists. Open the person to act, then remove or postpone the reminder.",
	},
} satisfies Record<string, TodoHint>;
